import { Country } from '../serializable/country.js';

// / ISO 3166-1 alpha-2 codes for all the supported countries.
// / For more information see: https://en.wikipedia.org/wiki/ISO_4217
export enum PhoneCountry {
  Albania = 'AL',
  Andorra = 'AD',
  Armenia = 'AM',
  Austria = 'AT',
  Azerbaijan = 'AZ',
  Belarus = 'BY',
  Belgium = 'BE',
  BosniaAndHerzegovina = 'BA',
  Bulgaria = 'BG',
  Croatia = 'HR',
  Cyprus = 'CY',
  CzechRepublic = 'CZ',
  Denmark = 'DK',
  Estonia = 'EE',
  FaroeIslands = 'FO',
  Finland = 'FI',
  France = 'FR',
  Georgia = 'GE',
  Germany = 'DE',
  Gibraltar = 'GI',
  Greece = 'GR',
  Hungary = 'HU',
  Iceland = 'IS',
  Ireland = 'IE',
  Italy = 'IT',
  Latvia = 'LV',
  Liechtenstein = 'LI',
  Lithuania = 'LT',
  Luxembourg = 'LU',
  NorthMacedonia = 'MK',
  Malta = 'MT',
  RepublicOfMoldova = 'MD',
  Monaco = 'MC',
  Montenegro = 'ME',
  Netherlands = 'NL',
  Norway = 'NO',
  Poland = 'PL',
  Portugal = 'PT',
  Romania = 'RO',
  Russia = 'RU',
  SanMarino = 'SM',
  Serbia = 'RS',
  Slovakia = 'SK',
  Slovenia = 'SI',
  Spain = 'ES',
  Sweden = 'SE',
  Switzerland = 'CH',
  Turkey = 'TR',
  Ukraine = 'UA',
  UnitedKingdom = 'GB',
  VaticanCity = 'VA',
}

const phoneCountryToPrefix = new Map<PhoneCountry, string>([
  [PhoneCountry.Albania, '+355'],
  [PhoneCountry.Andorra, '+376'],
  [PhoneCountry.Armenia, '+374'],
  [PhoneCountry.Austria, '+43'],
  [PhoneCountry.Azerbaijan, '+994'],
  [PhoneCountry.Belarus, '+375'],
  [PhoneCountry.Belgium, '+32'],
  [PhoneCountry.BosniaAndHerzegovina, '+387'],
  [PhoneCountry.Bulgaria, '+359'],
  [PhoneCountry.Croatia, '+385'],
  [PhoneCountry.Cyprus, '+357'],
  [PhoneCountry.CzechRepublic, '+420'],
  [PhoneCountry.Denmark, '+45'],
  [PhoneCountry.Estonia, '+372'],
  [PhoneCountry.FaroeIslands, '+298'],
  [PhoneCountry.Finland, '+358'],
  [PhoneCountry.France, '+33'],
  [PhoneCountry.Georgia, '+995'],
  [PhoneCountry.Germany, '+49'],
  [PhoneCountry.Gibraltar, '+350'],
  [PhoneCountry.Greece, '+30'],
  [PhoneCountry.Hungary, '+36'],
  [PhoneCountry.Iceland, '+354'],
  [PhoneCountry.Ireland, '+353'],
  [PhoneCountry.Italy, '+39'],
  [PhoneCountry.Latvia, '+371'],
  [PhoneCountry.Liechtenstein, '+423'],
  [PhoneCountry.Lithuania, '+370'],
  [PhoneCountry.Luxembourg, '+352'],
  [PhoneCountry.NorthMacedonia, '+389'],
  [PhoneCountry.Malta, '+356'],
  [PhoneCountry.RepublicOfMoldova, '+373'],
  [PhoneCountry.Monaco, '+377'],
  [PhoneCountry.Montenegro, '+382'],
  [PhoneCountry.Netherlands, '+31'],
  [PhoneCountry.Norway, '+47'],
  [PhoneCountry.Poland, '+48'],
  [PhoneCountry.Portugal, '+351'],
  [PhoneCountry.Romania, '+40'],
  [PhoneCountry.Russia, '+7'],
  [PhoneCountry.SanMarino, '+378'],
  [PhoneCountry.Serbia, '+381'],
  [PhoneCountry.Slovakia, '+421'],
  [PhoneCountry.Slovenia, '+386'],
  [PhoneCountry.Spain, '+34'],
  [PhoneCountry.Sweden, '+46'],
  [PhoneCountry.Switzerland, '+41'],
  [PhoneCountry.Turkey, '+90'],
  [PhoneCountry.Ukraine, '+380'],
  [PhoneCountry.UnitedKingdom, '+44'],
  [PhoneCountry.VaticanCity, '+379'],
]);

const prefixToPhoneCountry = new Map<string, PhoneCountry>([
  ['+355', PhoneCountry.Albania],
  ['+376', PhoneCountry.Andorra],
  ['+374', PhoneCountry.Armenia],
  ['+43', PhoneCountry.Austria],
  ['+994', PhoneCountry.Azerbaijan],
  ['+375', PhoneCountry.Belarus],
  ['+32', PhoneCountry.Belgium],
  ['+387', PhoneCountry.BosniaAndHerzegovina],
  ['+359', PhoneCountry.Bulgaria],
  ['+385', PhoneCountry.Croatia],
  ['+357', PhoneCountry.Cyprus],
  ['+420', PhoneCountry.CzechRepublic],
  ['+45', PhoneCountry.Denmark],
  ['+372', PhoneCountry.Estonia],
  ['+298', PhoneCountry.FaroeIslands],
  ['+358', PhoneCountry.Finland],
  ['+33', PhoneCountry.France],
  ['+995', PhoneCountry.Georgia],
  ['+49', PhoneCountry.Germany],
  ['+350', PhoneCountry.Gibraltar],
  ['+30', PhoneCountry.Greece],
  ['+36', PhoneCountry.Hungary],
  ['+354', PhoneCountry.Iceland],
  ['+353', PhoneCountry.Ireland],
  ['+39', PhoneCountry.Italy],
  ['+371', PhoneCountry.Latvia],
  ['+423', PhoneCountry.Liechtenstein],
  ['+370', PhoneCountry.Lithuania],
  ['+352', PhoneCountry.Luxembourg],
  ['+389', PhoneCountry.NorthMacedonia],
  ['+356', PhoneCountry.Malta],
  ['+373', PhoneCountry.RepublicOfMoldova],
  ['+377', PhoneCountry.Monaco],
  ['+382', PhoneCountry.Montenegro],
  ['+31', PhoneCountry.Netherlands],
  ['+47', PhoneCountry.Norway],
  ['+68', PhoneCountry.Poland], //  HACK: Prefix was incorrectly set to "+68" in older versions!
  ['+48', PhoneCountry.Poland],
  ['+351', PhoneCountry.Portugal],
  ['+40', PhoneCountry.Romania],
  ['+7', PhoneCountry.Russia],
  ['+378', PhoneCountry.SanMarino],
  ['+381', PhoneCountry.Serbia],
  ['+421', PhoneCountry.Slovakia],
  ['+386', PhoneCountry.Slovenia],
  ['+34', PhoneCountry.Spain],
  ['+46', PhoneCountry.Sweden],
  ['+41', PhoneCountry.Switzerland],
  ['+90', PhoneCountry.Turkey],
  ['+380', PhoneCountry.Ukraine],
  ['+44', PhoneCountry.UnitedKingdom],
  ['+379', PhoneCountry.VaticanCity],
]);

const countryToPhoneCountry = new Map<Country, PhoneCountry>([
  [Country.Austria, PhoneCountry.Austria],
  [Country.Hungary, PhoneCountry.Hungary],
  [Country.Romania, PhoneCountry.Romania],
  [Country.Slovakia, PhoneCountry.Slovakia],
  [Country.Slovenia, PhoneCountry.Slovenia],
]);

export function getPrefixFromPhoneCountry(country: PhoneCountry): string | undefined {
  return phoneCountryToPrefix.get(country);
}

export function getPhoneCountryFromPrefix(prefix: string): PhoneCountry | undefined {
  return prefixToPhoneCountry.get(prefix);
}

export function getPhoneCountryFromCountry(country: Country): PhoneCountry | undefined {
  return countryToPhoneCountry.get(country);
}

export function getPrefixNumberFromPhoneCountry(country: PhoneCountry): string {
  const prefix = phoneCountryToPrefix.get(country);
  if(prefix) {
    return prefix.substring(1);
  }

  return '';
}
